import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const DropboxIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2261_847)">
        <path
          d="M47.6 0H8.4C3.76081 0 0 3.76081 0 8.4V47.6C0 52.2392 3.76081 56 8.4 56H47.6C52.2392 56 56 52.2392 56 47.6V8.4C56 3.76081 52.2392 0 47.6 0Z"
          fill="#0061FF"
        />
        <path
          d="M17.2812 40.6875L28 47.5781L38.7188 40.6875L28 33.9062L17.2812 40.6875ZM17.2812 11.0469L6.45312 17.9375L38.7188 38.5L49.5469 31.6094L28 17.9375L38.7188 11.0469L49.5469 17.9375L17.2812 38.5L6.45312 31.6094L28 17.9375"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2261_847">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SystemWorkspaceIcon: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width="13"
      height={size}
      fill={color}
      className={className}
      viewBox="0 0 13 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 8.9615L7.6885 9.6885C7.8525 9.79233 8.01558 9.784 8.17775 9.6635C8.34008 9.543 8.39942 9.384 8.35575 9.1865L8.04025 7.83275L9.08275 6.9405C9.23658 6.80317 9.28433 6.64258 9.226 6.45875C9.16767 6.27475 9.03467 6.16925 8.827 6.14225L7.4635 6.027L6.9115 4.7385C6.83467 4.55767 6.6975 4.46725 6.5 4.46725C6.3025 4.46725 6.16533 4.55767 6.0885 4.7385L5.5365 6.027L4.173 6.14225C3.96533 6.16925 3.83233 6.27475 3.774 6.45875C3.71567 6.64258 3.76342 6.80317 3.91725 6.9405L4.95975 7.83275L4.64425 9.1865C4.60058 9.384 4.65992 9.543 4.82225 9.6635C4.98442 9.784 5.1475 9.79233 5.3115 9.6885L6.5 8.9615ZM6.5 13.9615L2.53075 15.6652C1.92825 15.9229 1.35583 15.8736 0.8135 15.5173C0.271167 15.1609 0 14.6597 0 14.0135V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H11.1923C11.6974 0 12.125 0.175 12.475 0.525C12.825 0.875 13 1.30258 13 1.80775V14.0135C13 14.6597 12.7288 15.1609 12.1865 15.5173C11.6442 15.8736 11.0718 15.9229 10.4693 15.6652L6.5 13.9615ZM6.5 12.3L11.0673 14.2673C11.1699 14.3121 11.2677 14.3025 11.3605 14.2385C11.4535 14.1743 11.5 14.0878 11.5 13.9788V1.80775C11.5 1.73075 11.4679 1.66025 11.4038 1.59625C11.3398 1.53208 11.2692 1.5 11.1923 1.5H1.80775C1.73075 1.5 1.66025 1.53208 1.59625 1.59625C1.53208 1.66025 1.5 1.73075 1.5 1.80775V13.9788C1.5 14.0878 1.5465 14.1743 1.6395 14.2385C1.73233 14.3025 1.83008 14.3121 1.93275 14.2673L6.5 12.3ZM6.5 1.5H1.5H11.5H6.5Z"
        fill="#424D57"
      />
    </svg>
  );
};
